module.exports = __webpack_public_path__ + "static/assets/de86d68639158020a4da508e0b60d4a1.svg";